<template>
  <div class="h-full flex flex-col overflow-y-hidden">
    <Suspense>
      <DashboardAsync />
      <template #fallback>
        <DashboardSkeleton />
      </template>
    </Suspense>
  </div>
</template>

<script setup>
import DashboardAsync from '@/pages/DashboardAsync.vue';
import DashboardSkeleton from '@/components/app/dashboard/DashboardSkeleton.vue';
</script>
